import type { InvariantRoute } from '@atlassian/react-resource-router/src/common/types';
import { SERVICE_DESK_PRODUCT } from './common/index.tsx';

export const projectSettingsServicedeskItsmTicketTypeFieldsRoute: InvariantRoute = {
	exact: true,
	name: 'project-settings-servicedesk-itsm-ticket-type-fields',
	path: `/jira/${SERVICE_DESK_PRODUCT}/projects/:projectKey/settings/request-types/category/:practice/request-type/:requestTypeId/:tabKey?`,
};
